import React from 'react'
import { StoresContext } from './StoresContext'

export const useStores = () => React.useContext(StoresContext)